import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { microsoftConsumerSecurityClient } from 'client-factories/MicrosoftConsumerSecurityClientFactoryV1';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { createOneOffAsyncApiThunk } from 'store/reduxHelpers';

import { getDefaultFamilyState, IFamilyState } from './familyState';

const initialState: IFamilyState = getDefaultFamilyState();

export const getFamilyMembersAsync = createOneOffAsyncApiThunk(
  'family/getFamilyMembersAsync',
  () => microsoftConsumerSecurityClient.familyMembers.getFamilyMembers(),
  ({ family }) => family.getFamilyMembersStatus
);

const handleGetFamilyMembersAsync = (builder: ActionReducerMapBuilder<IFamilyState>): void => {
  builder
    .addCase(getFamilyMembersAsync.pending, (state) => {
      state.getFamilyMembersStatus = ApiCallResultStatus.LOADING;
    })
    .addCase(getFamilyMembersAsync.fulfilled, (state, { payload }) => {
      state.familyMembers = payload.sort((m1, m2) => {
        if (m1.role === 'Admin' && m2.role !== 'Admin') {
          return -1;
        }
        if (m1.role !== 'Admin' && m2.role === 'Admin') {
          return 1;
        }
        return 0;
      });
      state.getFamilyMembersStatus = ApiCallResultStatus.SUCCESS;
    })
    .addCase(getFamilyMembersAsync.rejected, (state) => {
      state.getFamilyMembersStatus = ApiCallResultStatus.FAILED;
    });
};

export const familySlice = createSlice({
  name: 'family',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    handleGetFamilyMembersAsync(builder);
  },
});

export default familySlice.reducer;
